import { Button } from "@heroui/react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/features/auth/AuthProvider";

export function PublicLayout() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-separator bg-background/90 backdrop-blur">
        <nav
          aria-label="Main navigation"
          className="mx-auto flex h-20 max-w-6xl items-center justify-between px-6"
        >
          <a className="text-xl font-semibold tracking-tight" href="/">
            Colorthesia
          </a>
          <Button
            variant="secondary"
            onPress={() =>
              session?.isAuthenticated
                ? navigate(`/app/${session.activeTenant?.id ?? ""}`)
                : navigate("/signin", {
                    state: { backgroundLocation: location },
                  })
            }
          >
            {session?.isAuthenticated ? "Open workspace" : "Log in or sign up"}
          </Button>
        </nav>
      </header>
      <Outlet />
    </div>
  );
}
